import { t } from '@lingui/macro';
import { Box, Slider, Typography } from '@material-ui/core';

const DEFAULT_SENSITIVITY_MARKS = [1, 2, 3, 4, 5].map((value) => ({ value }));

export default function ThresholdSensitivitySlider({
    value,
    onChange,
    min = 1,
    max = 5,
    step = 1,
    marks = DEFAULT_SENSITIVITY_MARKS,
    leftLabel = t`More Sensitive`,
    rightLabel = t`Less Sensitive`,
    ariaLabel = t`Threshold Sensitivity Slider`,
    valueLabelDisplay = 'auto',
    containerClassName,
    labelClassName,
    sliderWrapClassName,
    sliderWrapStyle,
}) {
    return (
        <Box className={containerClassName} display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="caption" className={labelClassName}>
                {leftLabel}
            </Typography>
            <Box className={sliderWrapClassName} style={sliderWrapStyle}>
                <Slider
                    color="secondary"
                    value={value}
                    onChange={onChange}
                    min={min}
                    max={max}
                    step={step}
                    marks={marks}
                    valueLabelDisplay={valueLabelDisplay}
                    aria-label={ariaLabel}
                />
            </Box>
            <Typography variant="caption" className={labelClassName}>
                {rightLabel}
            </Typography>
        </Box>
    );
}
